// extracted by mini-css-extract-plugin
export default {"card":"Dashboard_card__ULiOd","product_item":"Dashboard_product_item__P5sK4","product_image":"Dashboard_product_image__3GuvZ"};